/**
 * Prompts download of a CSV file populated with provided data
 * @param table to populate file
 * @param filename the name of the file
 */
export default function downloadCsv(table: string[][], filename: string): boolean {
  // sanitize and covert to string
  const csv = table
    .map((row) => {
      return row
        .map((cell) => {
          // quote everything and quote double quotes inside the string
          return '"' + String(cell).replace(/"/g, '""') + '"';
        })
        .join(',');
    })
    .join('\n');

  const mime = 'text/csv';
  let blob = new Blob([csv], { type: mime });

  let a = document.createElement('a');
  a.download = filename;
  a.href = window.URL.createObjectURL(blob);
  a.dataset.downloadurl = [mime, a.download, a.href].join(':');

  let e = document.createEvent('MouseEvents');
  e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
  return a.dispatchEvent(e);
}
